import { useHMSUnblockAudio } from "../hms";
import { useLivekitUnblockAudio } from "../livekit";
import type { ProviderUnblockAudio } from "../types";
import { useProviderHook } from "./useProviderHook";

export const useProviderUnblockAudio = (): ProviderUnblockAudio =>
  useProviderHook({
    hms: useHMSUnblockAudio,
    livekit: useLivekitUnblockAudio,
  })();
